import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SwiperComponent } from "swiper/angular";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
  SwiperOptions,
  EffectCoverflow,
} from 'swiper';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
  EffectCoverflow,
]);

@Component({
  selector: 'lifedi-learning-center-content',
  templateUrl: './learning-center-content.component.html',
  styleUrls: ['./learning-center-content.component.scss']
})
export class LearningCenterContentComponent implements OnInit {
  @Input() centerDetail: any;
  @Input() theme: any;

  videoConfig: SwiperOptions = {
    // autoplay: {
    //   delay: 2000,
    //   disableOnInteraction: true
    // },
    speed: 900,
    loop: false,
    // effect: 'coverflow',
    grabCursor: true,
    slidesPerView: 1,
    autoHeight: true,
    pagination: { clickable: true, },
    navigation: true,
    // coverflowEffect: {
    //   rotate: 0,
    //   stretch: 0,
    //   depth: 100,
    //   modifier: 2.5
    // },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  };

  content2: any;
  vimeoUrl = 'https://player.vimeo.com/video/';

  content3_videos: any[] = [];
  content2_arr: any[] = [];
  researchText: any;

  banner = [1, 2, 3, 4, 5];

  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.getSanitizer();
  }

  getSanitizer() {
    this.content2 = this.sanitizer.bypassSecurityTrustHtml(this.centerDetail.CONTENT2_DETAIL);

    this.centerDetail.VIDEOS.forEach(el => {
      this.content3_videos.push({
        CENTER_ID: el.CENTER_ID,
        VIDEO_URL: this.sanitizer.bypassSecurityTrustResourceUrl(this.vimeoUrl + el.VIDEO_ID)
      })
    });

    this.centerDetail.CONTENT3.forEach(el => {
      this.content2_arr.push({
        CONTENT3_IMAGE_URL: el.CONTENT3_IMAGE_URL,
        CONTENT3_IMAGE_PROFILE: el.CONTENT3_IMAGE_PROFILE,
        CONTENT3_TITLE: el.CONTENT3_TITLE,
        CONTENT3_DETAIL: this.sanitizer.bypassSecurityTrustHtml(el.CONTENT3_DETAIL),
      })
    });

    this.researchText = this.sanitizer.bypassSecurityTrustHtml(this.centerDetail.RESEARCH_TEXT);
  }

}
